import { Button, Image, Upload, type UploadFile, type UploadProps } from "antd";
import type { UploadChangeParam } from "antd/es/upload";
import { useEffect, useState } from "react";
import { useUploadFileMutation } from "../app/features/auth/auth.api";
// import LinkIcon from "../../assets/images/external-link.png";
import CloseIcon from "../assets/icons/CloseIcon";
import { ENV_CONFIG } from "../config/global.config";
import useError from "../hooks/useError";
import { toast } from "../lib/toast";
import { getExtension, stringToArray } from "../utils/string.utils";
// import {
//   default as PDF_Icon,
//   default as PDF_IMG,
// } from "../../assets/images/pdf.svg";

type Props = {
  errorMessage?: string;
  form: any;
  name: string;
  disabled?: boolean;
  fileType?: boolean;
  accept?: string;
  onChange?: (url: string | null) => void;
  listFile?: boolean;
  size?: "large" | "middle" | "small";
  fileSize?: number;
  showImage?: boolean;
} & Omit<UploadProps, "name">;

function accessFile(accept: string) {
  return accept?.toLowerCase().includes("png") ||
    accept?.toLowerCase().includes("jpg") ||
    accept?.toLowerCase().includes("jpeg") ||
    accept?.toLowerCase().includes("svg") ||
    accept?.toLowerCase().includes("gif")
    ? true
    : false;
}

export default function FileUpload({
  errorMessage = "File upload fail",
  form,
  name,
  disabled,
  onChange,
  accept = ".png,.jpeg",
  listFile = true,
  fileType = true,
  size = "large",
  fileSize,
  showImage,
}: Props) {
  const [fileName, setFileName] = useState("কোনো ফাইল নির্বাচিত হয়নি");
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [uploadFile, { isLoading, error, data, isSuccess }] =
    useUploadFileMutation();

  useError(error, errorMessage);

  const handleUpload = (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const isImage = accessFile(getExtension(file?.name));

    const currentFileSize = fileSize || (isImage ? 5 : 10);

    const MAX_FILE_SIZE = currentFileSize * 1024 * 1024; // MB in bytes

    if (file?.size > MAX_FILE_SIZE) {
      toast(
        "error",
        `The file size exceeds the ${currentFileSize}MB limit. Please upload a smaller file`
      );
      return false;
    }

    uploadFile(formData);
    return false;
  };

  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    setFileList(info.fileList);

    if (info.file.status === "removed") {
      if (onChange) onChange(null);
      setFileName("কোনো ফাইল নির্বাচিত হয়নি");
    }
  };

  useEffect(() => {
    if (isSuccess && data?.file?.url) {
      const fullUrl = `${ENV_CONFIG.IMAGE_URL}/${data.file.url}`;
      setFileName(fullUrl);
      if (onChange) onChange(fullUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data]);

  useEffect(() => {
    if (fileType) {
      const timer = setTimeout(() => {
        const file = form.getFieldValue(
          //   true ? stringToArray(name, ".") : [name]
          stringToArray(name, ".")
        );

        if (file) {
          //   onChange && onChange(file);
          setFileName(file);
        }
      }, 1000);

      const file = form.getFieldValue(
        listFile ? stringToArray(name, ".") : [name]
      );

      if (file) {
        // onChange && onChange(file);
        setFileName(file);
      }

      return () => {
        clearTimeout(timer);
      };
    }
  }, [form, name, fileType, listFile]);

  const fileNameField =
    typeof fileName === "string" ? (fileName?.split("/")?.pop() as string) : "";

  const showFile =
    !fileName || fileName === "কোনো ফাইল নির্বাচিত হয়নি"
      ? null
      : typeof fileName === "string" &&
        (getExtension(fileName) === "jpg" ||
          getExtension(fileName) === "png" ||
          getExtension(fileName) === "jpeg")
      ? fileName
      : null;
  //   : PDF_Icon;

  const isCloseIcon =
    typeof fileName === "string" &&
    fileNameField &&
    fileNameField !== "কোনো ফাইল নির্বাচিত হয়নি";
  const cleanedName =
    typeof fileName === "string"
      ? decodeURIComponent(fileNameField?.replace(/^\d+-/, ""))
      : "";

  return (
    <div>
      <div className="relative w-full">
        <Upload
          name="file"
          beforeUpload={handleUpload}
          maxCount={1}
          accept={accept}
          showUploadList={false}
          onChange={handleChange}
          fileList={fileList}
          disabled={disabled || isLoading}
          className="!block w-full"
          style={{ width: "100%" }}
        >
          <Button
            className={`w-full flex items-center !justify-start !p-0 !border-display-medium rounded-md relative disabled:!bg-slate-100 ${
              size === "large" ? "!h-[46px]" : ""
            }`}
            block
            size={size}
            disabled={disabled}
            htmlType="button"
          >
            <span className="!flex justify-center items-center px-3 bg-[#5e718d] text-white h-full rounded-s">
              ফাইল ব্রাউজ করুন
            </span>
            <div className="px-2.5 gap-2 text-sm font-medium overflow-hidden whitespace-nowrap text-ellipsis text-theme-slate-400">
              {isLoading ? (
                "আপলোড হচ্ছে..."
              ) : (
                <span
                  className="overflow-hidden text-ellipsis"
                  style={{
                    direction: "unset",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {(cleanedName && cleanedName?.length > 30
                    ? `${cleanedName?.slice(0, 30)}...`
                    : cleanedName) || "কোনো ফাইল নির্বাচিত হয়নি"}

                  {/* {cleanedName || "কোনো ফাইল নির্বাচিত হয়নি"} */}
                </span>
              )}
            </div>
          </Button>
        </Upload>
        {isCloseIcon && !disabled ? (
          <span
            className="absolute right-3 top-2/4 -translate-y-2/4 text-body-text cursor-pointer size-4 flex items-center justify-center"
            onClick={() => {
              if (onChange) onChange(null);
              setFileName("");
            }}
          >
            <CloseIcon />
            {/* <CloseIcon width={8} height={8} /> */}
          </span>
        ) : null}
      </div>
      {showImage && showFile ? (
        <div className="mt-1.5 flex items-end gap-2">
          <Image
            src={fileName}
            // src={getExtension(fileName) === "pdf" ? PDF_IMG : fileName}
            width={getExtension(fileName) === "pdf" ? 100 : 200}
            height={getExtension(fileName) === "pdf" ? 150 : 100}
          />
          {/* <span className="text-accent flex items-center gap-1 text-xs mt-1">
            <a
              href={fileName}
              target="_blank"
              className="-mt-[2px] cursor-pointer"
              rel="noreferrer"
              download="Attachment"
            >
              <img className="size-3" src={LinkIcon} alt="" />
            </a>
          </span> */}
        </div>
      ) : null}
    </div>
  );
}
